/* eslint-disable dot-notation */
/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Calculator } from './calculator';

function CashDiscount({
    attributes, operators, formulaUpdated, setFormulaUpdated, params, fetchedFormula, setChangesMade,
}) {
    // const [adorcashparams, setadorcashParams] = useState({
    //     redeem: '',
    //     avail: '',
    // });
    const [adorcashparams, setadorcashParams] = useState(fetchedFormula[params]);

    const InputChange = (e, index) => {
        setChangesMade(true);
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '' || parseFloat(value) >= 100 || parseFloat(value) <= 0) {
            adorcashparams[id] = '';
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            adorcashparams[id] = value;
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
        delete adorcashparams['redeem'];
        formulaUpdated[params] = adorcashparams;
        setFormulaUpdated(formulaUpdated);
    };

    // function for 30 words validation for message field

    const handleMessageChange = (e) => {
        setChangesMade(true);
        e.preventDefault();
        const { id, value } = e.target;

        const splitWords = value.split(/\s+/);
        if (splitWords.length <= 30) {
            adorcashparams[id] = value;
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        } else {
            // Truncate the text to the first 30 words
            const truncatedText = splitWords.slice(0, 30).join(' ');
            adorcashparams[id] = truncatedText;
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: truncatedText,
            }));
        }
        delete adorcashparams['redeem'];
        formulaUpdated[params] = adorcashparams;
        setFormulaUpdated(formulaUpdated);
    };

    const handleCheckbox = (e) => {
        setChangesMade(true);
        const { id, checked } = e.target;
        adorcashparams[id] = checked;
        setadorcashParams((prevState) => ({
            ...prevState,
            [id]: checked,
        }));
        delete adorcashparams['redeem'];
        formulaUpdated[params] = adorcashparams;
        setFormulaUpdated(formulaUpdated);
    };

    return (
        <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
            <p className="text-f3 font-normal text-[#090406] pb-5">Cash Discount (%)</p>
            {/* <Calculator attributes={attributes} operators={operators} formulaUpdated={formulaUpdated} setFormulaUpdated={setFormulaUpdated} params={params} /> */}
            <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
                <div className="flex items-end -mx-0.5">
                    <div className="px-0.5 w-[27%]">
                        <div className="relative w-full">
                            <input
                                type="number"
                                id="percentage"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                                autoComplete="off"
                                onKeyDown={(e) => {
                                    if (e.which === 38 || e.which === 40) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    InputChange(e);
                                }}
                                onWheel={(e) => e.target.blur()}
                                value={adorcashparams.percentage}

                            />
                            <label htmlFor="percentage" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                Percentage
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                        </div>
                    </div>
                    <div className="px-0.5 w-[55%]">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="message"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                                autoComplete="off"
                                onKeyDown={(e) => {
                                    if (e.which === 38 || e.which === 40) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    handleMessageChange(e);
                                }}
                                onWheel={(e) => e.target.blur()}
                                value={adorcashparams.message}
                            />
                            <label htmlFor="message" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                Message
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                        </div>
                    </div>
                    <div className="w-auto relative checkbox custom-checkbox-offer flex ml-3">
                        <input
                            type="checkbox"
                            id="overdue_status"
                            className="cutsom-checkbox15"
                            onChange={(e) => handleCheckbox(e)}
                            checked={adorcashparams?.overdue_status === true}
                        />
                        <label htmlFor="overdue_status" className="cursor-pointer ml-2 font-normal text-base text-[#555259]">Check Overdue</label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CashDiscount;
